import cpf from 'assets/images/documents/CPF.svg'
import cnpj from 'assets/images/documents/CNPJ.svg'
import cnae from 'assets/images/documents/CNAE.svg'
import cns from 'assets/images/documents/CNS.svg'
import cnh from 'assets/images/documents/CNH.svg'
import ctps from 'assets/images/documents/carteira-de-trabalho.svg'
import rg from 'assets/images/documents/RG.svg'
import birthCertificate from 'assets/images/documents/certidao-de-nascimento.svg'
import voterCertificate from 'assets/images/documents/titulo-de-eleitor.svg'
import military from 'assets/images/documents/certificado-de-alistamento-militar.svg'
import vaccinationCard from 'assets/images/documents/vaccination-card.svg'

const documentsImages = {
  cpf: cpf.src,
  cnpj: cnpj.src,
  cnae: cnae.src,
  cns: cns.src,
  cnh: cnh.src,
  ctps: ctps.src,
  rg: rg.src,
  birth_certificate: birthCertificate.src,
  voter_certificate: voterCertificate.src,
  death_certificate: birthCertificate.src,
  military: military.src,
  vaccination_card: vaccinationCard.src,
}

export default documentsImages
